import algoliasearch from 'algoliasearch/lite';
import algoliasearchHelper from 'algoliasearch-helper';

import guideDropdownTemplate from 'templates/search/guide_dropdown.mustache';
import _ from 'lodash'

export default class DropdownGuideSearch {
  constructor(element) {
    this.input = element;
    this.raw_query = "";

    this.appId = this.input.dataset.appId;
    this.apiKey = this.input.dataset.appKey;
    this.appIndex = this.input.dataset.appIndex;
    this.appUri = this.input.dataset.appUri;

    this.client = algoliasearch(this.appId, this.apiKey);
    this.helper = algoliasearchHelper(this.client, this.appIndex, {
      attributesToRetrieve: ['title', 'slug', 'tagline'],
      hitsPerPage: 10,
      distinct: true
    });

    this.input.addEventListener('input', _.debounce(this._registerSearchInput.bind(this), 500));
    this.helper.on('result', this._render.bind(this));
  }

  _render(event) {
    var dropdownResults = guideDropdownTemplate.render(event.results, { hits: event.results.hits });
    this.input.dispatchEvent(new CustomEvent('open', { detail: dropdownResults }));
  }

  reset() {
    this.input.value = "";
    this.raw_query = "";
  }

  _registerSearchInput() {
    this.raw_query = this.input.value;
    if (this.raw_query.length > 0) {
      this.helper.setQuery(this.raw_query).search();
    } else {
      this.input.dispatchEvent(new CustomEvent('reset'));
    }
  }
}
